import React from "react";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M5 12.5l4 4L19 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronsRight = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M7 6l6 6-6 6M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const STATUS_LABEL = {
  completed: "Completed",
  next_up: "Next Up",
  locked: "Locked",
  emerges: "Emerges",
};

const STATUS_CLASS = {
  completed: "is-completed",
  next_up: "is-next-up",
  locked: "is-locked",
  emerges: "is-emerges",
};

const StatusBadge = ({ status }) => {
  const normalized = STATUS_LABEL[status] ? status : "locked";
  if (!STATUS_LABEL[status]) {
    console.warn("[YourElements] unknown status, falling back to locked:", status);
  }

  const label = STATUS_LABEL[normalized];
  const cls = STATUS_CLASS[normalized];

  return (
    <span className={`ye-badge ${cls}`}>
      {normalized === "completed" && <><span>{label}</span><CheckIcon /></>}
      {normalized === "next_up" && <><ChevronsRight /><span>{label}</span></>}
      {normalized === "locked" && <><LockIcon /><span>{label}</span></>}
      {normalized === "emerges" && <><span className="ye-emerges-ring" /><span>{label}</span></>}
    </span>
  );
};

export default StatusBadge;
